export function getSourceLines(namespace: string, hasSrcDir: boolean): string[] {
  return hasSrcDir
    ? [`@source "../../${namespace}/**/*.{ts,tsx}";`, `@source "./(${namespace})/**/*.{ts,tsx}";`]
    : [`@source "../${namespace}/**/*.{ts,tsx}";`, `@source "./(${namespace})/**/*.{ts,tsx}";`]
}
